export type UpdateProjectRequest = {
  pjtId: string;
  projectInformation?: ProjectInformationRequest;
  tstUseTypeCd?: string;
  componentRequirementList?: ComponentRequirementListRequset[];
  costEstimation?: CostEstimation;
  componentProjectList?: ComponentProject[];
  updateDateTime: string;
};

export type ProjectInformationRequest = {
  pjtName?: string;
  pjtDesc?: string;
  pjtStartPlnDate?: string;
  pjtEndPlnDate?: string;
  chnTypeGrpTypeCdList?: string[];
  trnsMsnTypeCd?: string;
  reqEstmtAnsDueDate?: string;
};

export type ComponentRequirementListRequset = {
  cpntReqId?: string;
  dipByRgn?: string;
  cpntId?: string;
  cpntReqDesc?: string;
  delFlg?: boolean;
  idx?: number;
};

type CostEstimation = {
  pjtBdgtAcqstnReqTypeCd?: string;
  statsOfAgreementOnBudgetaryTypeCd?: string;
};

export type ComponentProject = {
  cmpntPrjId: string;
};
